import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface SearchBarProps {
  query: string;
  onChange: (value: string) => void;
  onNext: () => void;
  onPrev: () => void;
  hasResults: boolean;
}

export const SearchBar = ({
  query,
  onChange,
  onNext,
  onPrev,
  hasResults,
}: SearchBarProps) => (
  <div className="px-5 py-2.5 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-gray-50 flex justify-between items-center">
    <h4 className="text-xs font-semibold text-gray-700 uppercase tracking-wider">
      Transcript
    </h4>
    <div className="relative w-64">
      <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-3.5 w-3.5 text-gray-400" />
      </div>
      <input
        type="text"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            if (e.shiftKey) {
              onPrev();
            } else {
              onNext();
            }
            e.preventDefault();
          }
          if (e.key === 'F3') {
            if (e.shiftKey) {
              onPrev();
            } else {
              onNext();
            }
            e.preventDefault();
          }
        }}
        placeholder="Search transcript..."
        className="py-1 pl-8 pr-8 block w-full text-xs rounded-md border-gray-200 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
      />
      {query && (
        <button
          type="button"
          className="absolute inset-y-0 right-0 pr-2 flex items-center"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <XMarkIcon className="h-3.5 w-3.5 text-gray-400 hover:text-gray-600" />
        </button>
      )}
    </div>
  </div>
);
